import { Component, Inject, ViewChild } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialog, MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { CompassService } from "huddyapi";

import { CompassStateModel, FamilyPatient, FamilyEntity } from "huddyapi";
import { GetPatientById, CommonService } from "huddyapi";
import { PatientStateModel } from "huddyapi";
import { BulkSubscriptionAssignment, DeleteBulkSubscriptionAssignment, PatientListItem, PatientEntity, BulkSubscription, BulkSubscriptionAssignmentAssessmentTaker, SaveBulkSubscriptionAssignment, GetGuidanceSubs, GetPatientListItems } from 'huddyapi';
import { Observable, Subscription, timer } from "rxjs";
import { ConfirmationDialog } from "../confirmation-dialog/confirmation-dialog.component";




@Component({
  selector: 'edit-assignment-dialog',
  templateUrl: 'edit-assignment-dialog.component.html',
  styleUrls: ["./edit-assignment-dialog.component.scss"]
})
export class EditAssignmentDialog  {
  mode : string = 'patient';
  subjectTypes : string[] = ['Independent', 'Dependent'];
  subjectTakesAssessment : string[] = ['Yes', 'No'];
  scoreLevels : string[] = ['Detailed', 'Component', 'None', 'Summary'];
  showAssessmentTaker : boolean = false;
  bulkSubscriptions : BulkSubscription[];
  patients : PatientListItem[] = [];
  family : FamilyEntity;
  patient : PatientEntity;
  patientId : number;
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;
  @Select(state => state.patientState) patientState$: Observable<PatientStateModel>;
  patientSubscription : Subscription;
  compassSubscription : Subscription;
 

  assignmentForm = this.formBuilder.group({
    bulkSubscriptionId : [null, [Validators.required]],
    scoreLevel: ['Detailed', Validators.required],
    assessmentTaker: [null],
    patient : [null, [Validators.required]],
    selfAssess : [null]

});

  constructor(
    public dialogRef: MatDialogRef<EditAssignmentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AssignmentDescriptor,
    public dialog: MatDialog,
    private compassService : CompassService,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    this.mode = this.data.mode;
    this.family = this.data.family;
    this.patientId = this.data.patientId;
    let assessmentTakerEmail : string = (this.data.assessmentTakerEmail) ? 
      this.data.assessmentTakerEmail : this.data.patientUsername;
      
    this.assignmentForm.controls.bulkSubscriptionId.setValue(this.getBulkSubscriptionId());
    this.assignmentForm.controls.scoreLevel.setValue(this.getScoreLevel());
    console.log('assessmentTaker', assessmentTakerEmail, 'patientId', this.data.patientId);
    this.assignmentForm.controls.assessmentTaker.setValue(assessmentTakerEmail);
    if (this.data.patient) {
      this.synchSelfAssess();
    } else if (this.data.patientId > -1) {
      this.store.dispatch(new GetPatientById(this.data.patientId));
    }

    if (this.isEditing()) {
      console.log('isEditing?=', this.isEditing(), this.mode);
      if (this.mode === 'patient')
        this.assignmentForm.controls.assessmentTaker.disable();
      else
        this.assignmentForm.controls.bulkSubscriptionId.disable();  
    } else {
      this.assignmentForm.controls.assessmentTaker.enable();
      this.assignmentForm.controls.bulkSubscriptionId.enable();  
    }
  }

  getPatientName() : string {
    return this.data.patientFriendlyName;
  }

  getPatientFriendlyName(patient : PatientListItem) : string {
    let ret : string = patient.firstName + ' ' + patient.lastName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = patient.username;
    }
    return ret;
  }

  getPatientDisplay(patient : PatientListItem) : string {
    console.log('enter get patientDisplay', patient);
    if (patient) {
      return patient.identifier + ' ' + patient.firstName + ' ' + patient.lastName;
    }
    return '';
  }

  ngOnInit(): void {
    this.compassSubscription = this.compassState$.subscribe((model: CompassStateModel) => {
      this.bulkSubscriptions = model.subscriptions;
      this.filterApplicableCompasses();
      console.log('bulksubscriptions', this.bulkSubscriptions);
    });
    this.patientSubscription = this.patientState$.subscribe((patientState: PatientStateModel) => {
      if (patientState && patientState.currentPatient && patientState.currentPatient.id === this.data.patientId) {
        this.patient = patientState.currentPatient;
        this.assignmentForm.controls.patient.setValue(this.patient);
        this.filterApplicableCompasses();
        this.synchSelfAssess();

        console.log('Current patient', this.patient);
      }
      if (patientState && this.mode === 'compass' && patientState.patientListItems) {
        this.patients = patientState.patientListItems;
      }
    });
  }

  synchSelfAssess() {
    let patientUsername = this.assignmentForm.value.patient.username;
    if (!patientUsername) {
      patientUsername = this.patient.username;
    }
    let assessmentTaker = this.assignmentForm.controls['assessmentTaker'].value;
    if (patientUsername) {
      patientUsername = patientUsername.trim();
    }
    if (assessmentTaker) {
      assessmentTaker = assessmentTaker.trim();
    }
    const selfAssess : boolean =  patientUsername === assessmentTaker;
    // console.log('synchSelfAssess', selfAssess, patientUsername, assessmentTaker, this.selfAssessChk);
    this.assignmentForm.controls.selfAssess.setValue(selfAssess);
  }

  public ngOnDestroy() {
    this.patientSubscription.unsubscribe();
    this.compassSubscription.unsubscribe();
  }

  isFormInValid() {
  // console.log('isFormInValid', 
  //   (this.assignmentForm.controls['bulkSubscriptionId'].invalid ), 
  //   this.assignmentForm.value.bulkSubscriptionId,
  //    this.assignmentForm.controls['patient'],
  //    this.assignmentForm.controls['patient'].invalid,
  //    this.patient
  //   );
    return !this.assignmentForm.controls || 
    this.assignmentForm.controls['bulkSubscriptionId'].invalid ||
    this.assignmentForm.value.bulkSubscriptionId === -1 ||
    this.assignmentForm.controls['scoreLevel'].invalid ||
    ((this.assignmentForm.controls['patient'] && this.assignmentForm.controls['patient'].invalid) ||
    !this.patient)

    ;
  }

  onSubmitForm(assignmentForm) {
   this.save();
  }


  getBulkSubscriptionId() : number {
   let ret : number =  this.data.bulkSubscriptionId ;
   if (!ret && this.bulkSubscriptions && this.bulkSubscriptions.length > 0) {
    ret = this.bulkSubscriptions[0].id
   }
   return ret;
  }

  onPatientSelected($event) {
    console.log('onpatientselected', $event.value);
    if ($event.option)
      this.patient = $event.option.value;
    else
      this.patient = $event.value;
    const selfAssess : boolean = this.assignmentForm.value.selfAssess;
    if (selfAssess && this.assignmentForm.value.patient ) {
      this.assignmentForm.controls.assessmentTaker.setValue(this.patient.username);
    } else if (!selfAssess) {
      this.assignmentForm.controls.assessmentTaker.setValue(CommonService.currentUserToView);
    }
  }

  selfAssessToggle($event) {
   
    if ($event.checked && this.assignmentForm.value.patient ) {
      this.assignmentForm.controls.assessmentTaker.setValue(this.patient.username);
    } else if (!$event.checked) {
      this.assignmentForm.controls.assessmentTaker.setValue(CommonService.currentUserToView);
    }
  }

  isEditing() : boolean {
    let ret : boolean = (this.data != undefined && this.data.bulkSubscriptionAssignmentId != undefined && this.data.bulkSubscriptionAssignmentId > 0);
    //console.log('isEditing', ret, this.scoredCompass);
    return ret;
  }

  getScoreLevel() : string {
   let ret : string = this.data.subjectScoreLevel;
   if (ret) {
    ret = ret.charAt(0).toUpperCase() + ret.substr(1).toLowerCase()
   } else {
    ret = 'Detailed';
   }
   return ret;
  }


  close() {
      this.dialogRef.close('done');
  }

  remove() {
    console.log('entering remove');
    this.store.dispatch(new DeleteBulkSubscriptionAssignment(this.data.bulkSubscriptionAssignmentId))
    .subscribe(t => {});
    timer(3000).subscribe(t =>  this.store.dispatch(new GetGuidanceSubs(true, false, this.data.patientUserId)), err => console.error(err));
    this.close();
  }


  save() {
    console.log('entering save');
   if (!this.isFormInValid()) {

    let bulkSubscriptionId : number = this.assignmentForm.controls['bulkSubscriptionId'].value;
    let bulkSubscription : BulkSubscription = this.bulkSubscriptions.find(s => s.id === bulkSubscriptionId);

    let compassId : number = bulkSubscription.compass.id;
    let assessmentTakers : BulkSubscriptionAssignmentAssessmentTaker[] = [];
  
    const assessmentTakerValue : string = this.assignmentForm.value.assessmentTaker;
    if (assessmentTakerValue != this.patient.username) {
      assessmentTakers.push(new BulkSubscriptionAssignmentAssessmentTaker({
        email: assessmentTakerValue,
        scoreReportingLevel: this.assignmentForm.controls['scoreLevel'].value.toUpperCase()
      }));
    } else {
      assessmentTakers.push(new BulkSubscriptionAssignmentAssessmentTaker({
        email: this.patient.username,
        scoreReportingLevel: this.assignmentForm.controls['scoreLevel'].value.toUpperCase()
      }));
    }
    
    let existingId : number = this.data.bulkSubscriptionAssignmentId;
    console.log('Existing id is ', existingId);
    let subjectNameEmail : string = (this.patient.username === this.data.assessmentTakerEmail) ?
    this.patient.username  : this.getPatientName();
        
    let assignment : BulkSubscriptionAssignment = new BulkSubscriptionAssignment(
      {
        id : existingId,
        bulkSubscriptionId: bulkSubscriptionId,
        compassId: compassId,
        subscriptionStatus: 'PENDING',
        login: this.patient.username,
        subjectUserId : this.patient.userId,
        subject: subjectNameEmail,
        subjectScoreLevel: assessmentTakers[0].scoreReportingLevel,
        assessmentTakers : assessmentTakers,
        patient: this.patient,
        subjectType : this.patient.username === assessmentTakers[0].email ? 'SELF' : 'LOG_FOR'
      }
    );
    if (existingId > 0) {  
      this.store.dispatch(new SaveBulkSubscriptionAssignment(assignment))
      .subscribe(t => {});
      timer(1000).subscribe(t =>  this.refreshParent(), err => console.error(err));
    } else {
      console.log('calling getbulksbuscriptionassignments',this.patient, assignment.subjectUserId, assessmentTakers[0].email);
      this.compassService.checkForBulkSubscriptionAssignments(bulkSubscriptionId, assignment.subjectUserId, assessmentTakers[0].email).subscribe((assignments : BulkSubscriptionAssignment[]) => {
        console.log('back from getbulksbuscriptionassignments', assignments);
        if (assignments && assignments.length > 0) {
          this.dialog.open(ConfirmationDialog, {
            width: '636px',
            data: {
              minWidth: '127px',
              title: 'Already exists',
              body: 'An assignment for this compass with the designated assessment taker and for this patient already exists.',
              buttons: [
                {
                  text: 'Cancel',
                  class: 'secondary',
                  handler: (): boolean => {
                    return false;
                  }
                }
              ]
            }
          });
        } else {
          this.store.dispatch(new SaveBulkSubscriptionAssignment(assignment))
            .subscribe(t => {});
             timer(50).subscribe(t =>  this.refreshParent(), err => console.error(err));
        }
      });

    }
    
  }
  }


  filterApplicableCompasses() {
    if (this.bulkSubscriptions && this.bulkSubscriptions.length > 0 && this.patient && this.patient.id > -1)
    {
      this.bulkSubscriptions = this.bulkSubscriptions.filter(s => s.providerId === this.patient.providerId);
    }
  }


  refreshParent() {
    if (this.mode === 'patient')
      this.store.dispatch(new GetGuidanceSubs(true, false, this.data.patientUserId));
    else 
      console.log('closing');
      this.close();  
  }

  patientSearchInputChanged($event) {
    console.log($event);
    let search : string = $event;
    if (search.length > 3) {
      let bulkSubscriptionId : number = this.assignmentForm.controls['bulkSubscriptionId'].value;
      let bulkSubscription : BulkSubscription = this.bulkSubscriptions.find(s => s.id === bulkSubscriptionId);
      this.store.dispatch(new GetPatientListItems(bulkSubscription.providerId, search));
    }
  }

  getCompassName() : string {
    let ret : string = '';
    let bulkSubscriptionId : number = this.assignmentForm.controls['bulkSubscriptionId'].value;
    let bulkSubscription : BulkSubscription = this.bulkSubscriptions.find(s => s.id === bulkSubscriptionId);
    if (bulkSubscription) {
      ret = bulkSubscription.compass.name;
    }
    return ret;
  }

}

export interface AssignmentDescriptor {
  mode : string,
  patientId : number;
  patient? : PatientListItem,
  assessmentTakerEmail : string;
  assessmentTakerUserId : number;
  assignedDt : string;
  assignedBy : string;
  compassId : number;
  patientUsername : string;
  bulkSubscriptionId : number;
  bulkSubscriptionAssignmentId: number;
  guidanceSubscriptionId : number;
  subjectScoreLevel : string;
  patientFriendlyName : string;
  patientUserId : number;
  family? : FamilyEntity;
}

export interface MiniAssessmentTaker {
  email : string,
  scoreLevel : string
}